/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

function WelcomePageDots({ showDots, length, position }) {
  const emptyArray = useMemo(
    () => ((Array.from({ length }))),
    [length],
  );
  return (
    <div className="dtv-html5-c-welcome-page-dots">
      {
        showDots
          && emptyArray?.map((undef, index) => (
            <div
              /* eslint-disable-next-line react/no-array-index-key
                  -- it's okay in this keys since it's only presentational */
              key={`welcome-page-dot-${index}`}
              className={`dtv-html5-c-welcome-page__dot ${
                position === index ? 'dtv-html5-c-welcome-page__dot--active' : ''
              }`}
            />
          ))
      }
    </div>
  );
}

WelcomePageDots.propTypes = {
  showDots: PropTypes.bool,
  length: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
};

WelcomePageDots.defaultProps = {
  showDots: false,
};

export default memo(WelcomePageDots);
